export default "__VITE_ASSET__CJOIgp7a__"